import { render } from "./jmdetail.vue?vue&type=template&id=f5e6cf4a&scoped=true"
import script from "./jmdetail.vue?vue&type=script&lang=js"
export * from "./jmdetail.vue?vue&type=script&lang=js"

import "./jmdetail.vue?vue&type=style&index=0&id=f5e6cf4a&lang=scss&scoped=true"
import "./jmdetail.vue?vue&type=style&index=1&id=f5e6cf4a&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e6cf4a"]])

export default __exports__